import { servicesQuery } from '@/services/api';
import type { ServicesApiGetCopilotSessionsResponse } from '@/services/api/services-api';
import { useAuth } from '@/services/auth';

export function useCopilotHistory() {
  const auth = useAuth();

  return servicesQuery.getCopilotSessions.useInfiniteQuery({
    queryKey: ['copilotHistory'],
    initialPageParam: 1,
    queryData: ({ pageParam }: { pageParam: number }) => ({
      params: { accountId: auth.account.id },
      query: { page: pageParam },
    }),
    getNextPageParam: (lastPage: { body: ServicesApiGetCopilotSessionsResponse }) => {
      const { pagination } = lastPage.body.meta;
      const totalPages = Math.ceil(pagination.total / pagination.size);
      return pagination.page < totalPages ? pagination.page + 1 : undefined;
    },
  });
}
